import { Check } from "lucide-react";

const STEPS = [
  { key: "photo", label: "Photo" },
  { key: "style", label: "Style" },
  { key: "preview", label: "Preview" },
  { key: "groomer", label: "Groomer Card" },
];

export const ProgressStepper = ({ current }) => {
  const idx = STEPS.findIndex((s) => s.key === current);
  return (
    <div
      data-testid="progress-stepper"
      className="w-full max-w-2xl mx-auto px-4 pt-4 pb-2"
    >
      <div className="flex items-center">
        {STEPS.map((s, i) => {
          const done = i < idx;
          const active = i === idx;
          return (
            <div key={s.key} className="flex items-center flex-1 last:flex-none">
              <div className="flex items-center gap-2 sm:gap-3">
                <div
                  data-testid={`step-dot-${s.key}`}
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border transition-all ${
                    done
                      ? "bg-[#0f172a] text-white border-[#0f172a]"
                      : active
                        ? "bg-[#ff6b4a] text-white border-[#ff6b4a] shadow-md shadow-[#ff6b4a]/30"
                        : "bg-white text-[#64748b] border-[#eae4d9]"
                  }`}
                >
                  {done ? <Check className="w-4 h-4" /> : i + 1}
                </div>
                <span
                  className={`hidden sm:inline text-xs font-semibold tracking-wide ${
                    active ? "text-[#0f172a]" : "text-[#64748b]"
                  }`}
                >
                  {s.label}
                </span>
              </div>
              {i < STEPS.length - 1 && (
                <div
                  className={`flex-1 h-[2px] mx-2 sm:mx-3 rounded-full ${
                    done ? "bg-[#0f172a]" : "bg-[#eae4d9]"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressStepper;
